import React from 'react';
import { FlashcardSet } from '../types';
import { ArrowLeft } from 'lucide-react';

interface TopicHeaderProps {
  selectedTopic: FlashcardSet;
  isRevisionMode: boolean;
  onBackToTopics: () => void;
  className?: string;
}

const TopicHeader: React.FC<TopicHeaderProps> = ({
  selectedTopic,
  isRevisionMode,
  onBackToTopics,
  className = ''
}) => {
  return (
    <div className={`relative mb-6 ${className}`}>
      {/* Back Button - Absolute positioned, icon-only */}
      <button
        onClick={onBackToTopics}
        className="
          absolute left-0 top-0
          flex items-center justify-center
          w-12 h-12
          bg-secondary hover:bg-secondary/80
          dark:bg-secondary dark:hover:bg-secondary/80
          text-foreground
          rounded-xl
          border-2 border-b-[4px] border-border
          hover:border-border/80
          active:border-b-2 active:translate-y-[2px]
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
          dark:focus:ring-offset-background
        "
        aria-label="Zpět na výběr témat"
        title="Zpět na témata"
      >
        <ArrowLeft className="w-5 h-5" />
      </button>

      {/* Title and Description - Centered */}
      <div className="text-center pt-1">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground mb-2">
          {selectedTopic.title}
        </h1>


      </div>
    </div>
  );
};

export default TopicHeader;
